import { render } from "./PopupBuildingsPlan.vue?vue&type=template&id=37e80ed8&scoped=true"
import script from "./PopupBuildingsPlan.vue?vue&type=script&lang=js"
export * from "./PopupBuildingsPlan.vue?vue&type=script&lang=js"

import "@css/popup.css?vue&type=style&index=0&id=37e80ed8&scoped=true&lang=css"
import "./PopupBuildingsPlan.vue?vue&type=style&index=1&id=37e80ed8&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37e80ed8"]])

export default __exports__